<template>
	<div class="productcenter">
		<div class="bg">
			<img src="@imgs/cpzx.png" width="195px" height="92px" alt="" class="cpzx" />
		</div>
		<div style="height: 50px; width: 100%;"></div>
		<div class="tabs">
			<div class="tab_item" v-for="item in tabList" :key="item.type"
				:class="{'active' : item.type === rightIndex}" @click="rightTap(item.type)">{{item.name}}</div>
		</div>
		<div class="prolist">
			<div class="proitem" v-for="item in goodList" :key="item.id">
				<img class="img-width" :src="item.img" alt="" />
				<p>{{ item.name }}</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				goodList: [{
						id: 1,
						img: require("@imgs/1.jpg"),
						name: '盐酸苯环壬酯片（飞赛乐）',

					},
					{
						id: 2,
						img: require("@imgs/3.jpg"),
						name: '西地碘含片(华素片)',

					},
					{
						id: 3,
						img: require("@imgs/11.jpg"),
						name: '复方岩白菜素片',

					},
					{
						id: 4,
						img: require("@imgs/22.jpg"),
						name: '酚氨咖敏颗粒（克感敏颗粒）',
					},
				],
				rightIndex: 0,
				tabList: [{
						name: '药品',
						type: 0
					},
					{
						name: '医疗器械',
						type: 1
					}
				],
			};
		},
		methods: {
			rightTap(e) {
				this.rightIndex = e
				if (e == 0) {
					this.goodList = [{
							id: 1,
							img: require("@imgs/1.jpg"),
							name: '盐酸苯环壬酯片（飞赛乐）',
						},
						{
							id: 2,
							img: require("@imgs/3.jpg"),
							name: '西地碘含片(华素片)',
						},
						{
							id: 3,
							img: require("@imgs/11.jpg"),
							name: '复方岩白菜素片',
						},
						{
							id: 4,
							img: require("@imgs/22.jpg"),
							name: '酚氨咖敏颗粒（克感敏颗粒）',
						},
					]
				} else if (e == 1) {
					this.goodList = [{
							id: 1,
							img: require("@imgs/01.jpg"),
							name: '一次性使用气流雾化器',
						},
						{
							id: 2,
							img: require("@imgs/02.jpg"),
							name: '一次性使用输液器 带针',
						},
						{
							id: 3,
							img: require("@imgs/03.jpg"),
							name: '医用雾化器',
						},
						{
							id: 4,
							img: require("@imgs/04.jpg"),
							name: '一次性使用鼻氧管（双鼻式）',
						},
					]
				}
			},
			toDetail(item) {
				this.$router.push({
					path: '/goodDetail?id=' + item.id
				})
			}
		}
	};
</script>

<style lang="scss" scoped>
	.productcenter {
		.tabs {
			width: 400px;
			height: 60px;
			margin: auto;
			display: flex;

			.tab_item {
				flex: 1;
				margin: 0px 10px;

				cursor: pointer;
				text-align: center;
				line-height: 60px;
				font-size: 24px;
			}

			.active {
				background-color: #17a2b8;
				color: #ffffff;
			}
		}

		.prolist {
			width: 960px;
			margin: 0 auto;
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			margin-top: 30px;



			.proitem {
				background: #ffffff;
				border: 1px solid #cccccc;
				// margin: 13.5px 0;
				margin-bottom: 30px;
				padding: 0 10px;

				img {
					width: 200px;
					height: 180px;
				}

				p {
					font-weight: bold;
				}
			}
		}
	}
</style>
